
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose, lifecycle } from 'recompose'
import { translate } from 'react-switch-lang'

import MyController from '../../core/components/MyController'
import ViewRoomList from '../../views/room/ViewRoomList'
import RoomManager from '../../business/RoomManager'

class RoomListController extends MyController {
	constructor(props) {
		super(props)
		this.state.isLoading = false
		this.bRoom = new RoomManager(this)
	}

	onGetRoomList = (textSearch) => {
		return this.bRoom.getRoomList(textSearch)
	}
	render() {
		return (
			<React.Fragment>
				{super.render()}
				<ViewRoomList
					onGetRoomList={this.onGetRoomList}
				/>
			</React.Fragment>
		)
	}
}

const enhance = compose(
	translate,
	withRouter,
	connect(
		(state, props) => ({

		}),
		(dispatch, props) => ({

		}),
	),
	lifecycle({
		componentDidMount() {
		}
	})
)


export default enhance(RoomListController)